import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { makeStyles, mergeClasses, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  title: {
    fontWeight: 'bold',
    fontSize: 26,
    lineHeight: '36px',
    ...shorthands.margin('0px'),
  },
  description: {
    lineHeight: '20px',
    maxWidth: 560,
    ...shorthands.margin('8px', '0px', '24px', '0px'),
  },
});

export const StepHeader = ({
  title,
  description,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useStyles();

  return (
    <React.Fragment>
      <h1 className={mergeClasses('step-title', classes.title)}>
        {i18n.getString(title)}
      </h1>
      <p className={mergeClasses('step-description', classes.description)}>
        {i18n.getString(description)}
      </p>
    </React.Fragment>
  );
};

StepHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
